import React from 'react';
import { motion } from 'framer-motion';

const InfoBar = () => {
  return (
    <div className="bg-primary text-white py-2">
      <div className="container mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ 
            delay: 0.8,
            duration: 0.5,
            type: "spring", 
            stiffness: 100
          }}
          className="text-center text-sm"
        >
        JDP Finance Pty Ltd  ABN 22 686 530 361, Authorised Credit Representative Number 569556,
         Facilitating Loans Provided by Strawberry Loans Pty Ltd ABN 74 621 474 655, Australian Credit Licence 519 253.
        </motion.div>
      </div>
    </div>
  );
};

export default InfoBar; 